import React, { PureComponent } from 'react';
import styles from 'components/KeywordSearch.scss';
import Input from 'Common/Input';

class KeywordSearch extends PureComponent<*, *> {
  render() {
    const { fields, resultsLength } = this.props;

    return (
      <div>
        <Input
          styles={styles}
          name={'keyword'}
          label={'Keyword'}
          selectedValue={fields.keyword}
          isLabelHidden={true}
          placeholderText={'Keyword search'}
          isValid={fields.keyword && resultsLength > 0}
          showIcon={true}
          iconName={'search'}
        />
      </div>
    );
  }
}

export default KeywordSearch;



// WEBPACK FOOTER //
// ./src/Results/KeywordSearch/index.js